/*
  The backend writes every date and time of the admin API in UTC (README of legaleyse-backend, "Dates and times"). The ones that are not
  instants of the event stream (the time of an alert, of an event, of a run) are ISO-8601 local date-times with no offset, such as
  '2026-10-17T07:45:09.207962'. JavaScript reads a date-time with no offset in the zone of the browser, which shows UTC as if it were
  the time on the viewer's clock: two hours early in Malta in summer. So a time with no offset is read as UTC, and shown in the viewer's
  zone. A time that has an offset (or a Z), a number of milliseconds or a Date is left as it is.
*/
const hasNoOffset = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/;

export const parseServerTime = value =>
    typeof value === 'string' && hasNoOffset.test(value)
        ? // Only milliseconds are certain to be read by every browser: the backend writes microseconds
          new Date(`${value.replace(/(\.\d{3})\d+$/, '$1')}Z`)
        : new Date(value);

/*
  The zone the viewer's clock is in, by its name ('Europe/Malta'), which is the zone a time is shown in (FriendlyDate). Empty when the
  browser does not say.
*/
export const viewerTimeZone = () => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    } catch (e) {
        return '';
    }
};
